module.exports = __webpack_public_path__ + "static/media/Flaticon.7ad910ab.ttf";